import { useContext, useState } from 'react';

import { Box, Button, Typography } from '@mui/material';

import { Context } from '@/context';
import { FANTASY } from '@/helpers/biwenger-helper';

const CustomTabs = ({ player, handleClick, selected, weeks }) => {
    const tabsPerPage = 5;
    const totalTabs = weeks?.length ?? 0;
    const playerStats = player?.playerStats ?? player?.estadisticas?.playerStats;
    const biwengerStats = player?.biwengerStats;

    const { state } = useContext(Context);
    const { preferences } = state;

    const [currentPage, setCurrentPage] = useState(0);

    const prevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const nextPage = () => {
        const totalPages = Math.ceil(totalTabs / tabsPerPage);
        if (currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    const getPorcentaje = (puntos) => {
        if (puntos === 0) {
            return 0;
        }

        const percentage = (puntos * 100) / 35;

        return percentage;
    };

    const getValue = (tabIndex) => {
        if (preferences.fantasy === FANTASY.BIWENGER) {
            const value =
                biwengerStats
                    ?.find((x) => x.week == tabIndex)
                    ?.partido?.points?.find((x) => x.id == preferences.mode)?.points ?? '-';

            return value;
        }

        const value = playerStats?.find((x) => x.w === tabIndex)?.tp ?? '-';
        return value;
    };

    const renderTabs = () => {
        const start = currentPage * tabsPerPage;
        const end = start + tabsPerPage;
        const tabsToDisplay = weeks?.slice(start, end);

        return tabsToDisplay?.map((tabIndex) => (
            <Box
                className={`tab-to-display ${tabIndex === selected ? 'tab-to-display-active' : ''}`}
                key={tabIndex}
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '20%',
                    cursor: 'pointer',
                }}
                onClick={() => handleClick(tabIndex)}
            >
                <Typography
                    style={{
                        fontSize: '14px',
                        zIndex: '2',
                        position: 'relative',
                    }}
                    variant="h6"
                    className="tab-to-display-text"
                >
                    J{tabIndex}
                </Typography>
                <Typography
                    style={{ fontSize: '16px', zIndex: '2', position: 'relative' }}
                    variant="h6"
                    className="tab-to-display-text"
                >
                    {getValue(tabIndex)}
                </Typography>
                <div className="porcentaje" style={{ height: `${getPorcentaje(getValue(tabIndex))}%` }}></div>
            </Box>
        ));
    };

    return (
        <Box className="tabs-container">
            <Button
                className="arrow-button"
                onClick={prevPage}
                disabled={currentPage === 0}
                style={{ opacity: currentPage === 0 ? 0.3 : 1 }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#ffffff" d="M20 15V9H12V4.16L4.16 12 12 19.84V15H20Z" />
                </svg>
            </Button>
            <Box className="tabs">{renderTabs()}</Box>
            <Button
                className="arrow-button"
                onClick={nextPage}
                disabled={currentPage === Math.ceil(totalTabs / tabsPerPage) - 1}
                style={{ opacity: currentPage === Math.ceil(totalTabs / tabsPerPage) - 1 ? 0.3 : 1 }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#ffffff" d="M4 15V9h8V4.16L19.84 12L12 19.84V15H4Z" />
                </svg>
            </Button>
        </Box>
    );
};

export default CustomTabs;
